import { PortalIcon, type PortalIconProps } from './portal-icon';

/** Sign out. */
export function LogoutIcon(props: PortalIconProps) {
  return (
    <PortalIcon {...props}>
      <path d="M14.4 4.6H7a1.8 1.8 0 0 0-1.8 1.8v11.2A1.8 1.8 0 0 0 7 19.4h7.4" />
      <path d="M10.8 12h9m0 0-3-3m3 3-3 3" />
    </PortalIcon>
  );
}
